import {
  type EnvironmentProviders,
  InjectionToken,
  makeEnvironmentProviders,
} from '@angular/core';

export type IconMode = 'font' | 'svg';

export interface IconsConfig {
  mode: IconMode;
}

const DEFAULT_ICON_BASE_URL = '/icon-sets/material-symbols-outlined-400';

export const ICON_MODE = new InjectionToken<IconMode>('ICON_MODE');
export const ICON_BASE_URL = new InjectionToken<string>('ICON_BASE_URL');

export function provideIcons(config: IconsConfig): EnvironmentProviders {
  return makeEnvironmentProviders([
    {
      provide: ICON_MODE,
      useValue: config.mode,
    },
    {
      provide: ICON_BASE_URL,
      useValue: DEFAULT_ICON_BASE_URL,
    },
  ]);
}
